export default function SectionHead({ num, title, meta, metaHref }) {
  return (
    <div className="flex flex-wrap items-baseline gap-5 border-b border-ink pb-3">
      <span className="font-mono text-[11px] tracking-[0.2em] text-primary">{num}</span>
      <h2 className="font-reactor text-[clamp(26px,3.4vw,44px)] font-bold leading-none [font-variation-settings:'wdth'_5]">
        {title}
      </h2>
      <span className="flex-1" />
      {metaHref ? (
        <a
          href={metaHref}
          target="_blank"
          rel="noreferrer"
          className="font-mono text-[11px] uppercase tracking-[0.14em] text-primary"
        >
          {meta}
        </a>
      ) : (
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-muted">{meta}</p>
      )}
    </div>
  );
}
